import {
  Category,
  ImpactCo2Answer,
} from '@/domain/impact-co2/entities/question.entity';
import { translate } from '@/ui/i18n';

import { extraColumnsByCategory } from './columns-by-category';
import { FormatColumnHeader } from './format-column-header';
import { FormatColumnValue } from './format-column-value';

export class TabsBuilder {
  private answers: ImpactCo2Answer[];

  constructor(answers: ImpactCo2Answer[]) {
    this.answers = answers;
  }

  build(category: Category): string[][] {
    const answers = this.getAnswersByCategory(category);
    const extraColumns = extraColumnsByCategory[category];
    const header = [
      translate('ExcelReport.header.category'),
      translate('ExcelReport.header.sector'),
      translate('ExcelReport.header.label'),
      translate('ExcelReport.header.tags'),
      translate('ExcelReport.header.external'),
      ...this.getExtraColumnHeaders(category, extraColumns),
    ];
    const rows = answers.map((answer) => {
      return [
        FormatColumnValue.category(answer.category),
        FormatColumnValue.sector(answer.sector),
        FormatColumnValue.label(answer.values),
        FormatColumnValue.tags(answer.values),
        FormatColumnValue.external(answer.isExternal),
        ...this.getExtraColumnValues(answer, extraColumns),
      ];
    });
    return [header, ...rows];
  }

  private getAnswersByCategory(category: Category): ImpactCo2Answer[] {
    return this.answers.filter((x) => x.category === category);
  }

  private getExtraColumnHeaders(
    category: Category,
    extraKeys: string[],
  ): string[] {
    const headers = extraKeys.map((key) => {
      const headerTranslated = FormatColumnHeader.translate(category, key);
      return headerTranslated;
    });
    return headers;
  }

  private getExtraColumnValues(
    answer: ImpactCo2Answer,
    extraKeys: string[],
  ): string[] {
    const category = answer.category;
    const values: string[] = extraKeys.map((key) => {
      const value = (answer.values as Record<string, unknown>)[key];
      const valueFormatted = FormatColumnValue.value(category, key, value);
      return valueFormatted;
    });
    return values;
  }
}
